var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center mt-4 mb-2 button-bar"},_vm._l((_vm.buttons),function(button,index){return _c('SidebarButton',{key:index,attrs:{"id":index,"borderColor":button.borderColor,"fillColor":button.fillColor,"color":button.color,"caption":button.caption,"active":button.active},on:{"clicked":_vm.buttonClicked}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc5a8220","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarButtons.vue
// module id = null
// module chunks = 